<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    initialOption: {
      type: String,
      default: 'objective_achieved',
    },
    disableButtons: {
      type: Boolean,
      default: false,
    },
    columnStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentDisplayTheme: '',
      selectedOption: '',
    };
  },
  computed: {
    mainContainerStyles() {
      if (!this.columnStyle) return {};
      return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowY: 'auto',
        maxHeight: '300px',
      };
    },
    buttonStyles() {
      if (!this.columnStyle) return {};
      return {
        width: '100%',
      };
    },
    mainDivStyles() {
      if (!this.columnStyle) return {};
      return {
        width: '90%',
      };
    },
  },
  created() {
    this.currentDisplayTheme = window.localStorage.color_scheme;
  },
  mounted() {
    this.selectedOption = this.initialOption;
    this.setDefaultOption();
  },
  methods: {
    selectedClass(option) {
      return this.selectedOption === option.id;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.$emit('onChangeResolutionOption', this.selectedOption);
    },
    setDefaultOption() {
      this.$emit('onChangeResolutionOption', this.selectedOption);
    },
  },
};
</script>

<template>
  <div :style="mainDivStyles">
    <div
      :style="mainContainerStyles"
      class="flex gap-2 inputRadioGroupStylized"
    >
      <div
        v-for="option in items"
        :id="option.id"
        :key="option.id"
        :style="
          columnStyle
            ? {
                boxSsizing: 'border-box',
                border: `1px solid ${
                  currentDisplayTheme === 'dark' ? '#604444' : '#e7e7e7'
                }`,
                borderRadius: '7px',
              }
            : {}
        "
        :class="{
          'bg-slate-700':
            selectedClass(option) && currentDisplayTheme === 'dark',
          'bg-woot-100':
            selectedClass(option) && currentDisplayTheme !== 'dark',
        }"
        @click="selectOption(option.id, $event)"
      >
        <woot-button
          class="clear"
          color-scheme="secondary"
          :style="buttonStyles"
          :disabled="disableButtons"
        >
          {{ option.title }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
